<script setup lang="ts">
import { onMounted, onBeforeUnmount, computed, ref } from "vue";
import { RouterView } from "vue-router";
import { ElConfigProvider } from "element-plus";
import { useAppStore } from "@/stores/modules/app";
import { useWebStore } from "@/stores/modules/web";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { isMobile } from "@/utils/is";
import { Backtop } from "@/components/Backtop";
window.CESIUM_BASE_URL = "libs/cesium/";
const appStore = useAppStore();
const webStore = useWebStore();
// 判断页面是否在手机端打开
const scrollTop = ref(0);
const oldScrollTop = ref(0);
if (isMobile()) {
  // console.log("当前在手机端");
  appStore.setMobile(true);
} else {
  // console.log("当前在PC端");
  appStore.setMobile(false);
}
let headerHeight = computed(() => appStore.getHeaderHeight);

const resizeChange = () => {
  let width = document.body.clientWidth;
  let bannerHeight: number;
  let Banner = (630 / 1920) * window.innerWidth;
  appStore.setPageHeader(Banner);
  bannerHeight = (540 / 1200) * width;
  bannerHeight = bannerHeight > 540 ? 540 : bannerHeight;

  webStore.setBannerHeight(bannerHeight);
  if (width < 800 && headerHeight.value == 66) {
    appStore.setHeaderHeight(46);
  }
  if (width > 800 && headerHeight.value == 46) {
    appStore.setHeaderHeight(66);
  }
};
const scrollHandle = () => {
  scrollTop.value = document.documentElement.scrollTop || document.body.scrollTop;
  // 滚动条滚动的距离
  const scrollStep = scrollTop.value - oldScrollTop.value;
  // 更新——滚动前，滚动条距文档顶部的距离
  oldScrollTop.value = scrollTop.value;
  if (scrollStep >= 0 && scrollTop.value > 50) {
    // header现在会固定在页面顶端，不会随页面滚动消失
    // appStore.setHeaderShow(false);
  } else {
    appStore.setHeaderShow(true);
  }
};
onMounted(() => {
  // 页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
  window.addEventListener("resize", resizeChange);
  resizeChange();
  window.addEventListener("scroll", scrollHandle); // 绑定页面的滚动事件
});
onBeforeUnmount(() => {
  window.removeEventListener("scroll", scrollHandle);
  window.removeEventListener("resize", resizeChange);
});
</script>

<template>
  <el-config-provider
    size="default"
    :z-index="0"
    :locale="zhCn"
    :button="{
      autoInsertSpace: true,
    }">
    <RouterView />
    <Backtop></Backtop>
  </el-config-provider>
</template>

<style lang="scss">
@media (min-width: 1000px) {
  // 头部
  @include b(layout-header) {
    @include e(right) {
      .iconBox {
        animation: showAnimation 0.5s normal forwards;
      }
    }
  }
}
@media (max-width: 1000px) {
  // 头部
  @include b(layout-header) {
    @include e(right) {
      .iconBox {
        animation: hideAnimation 0.5s normal forwards;
      }
    }
  }
}
@media (min-width: 800px) {
  // 头部
  @include b(layout-header) {
    @include e(right) {
      .el-menu-popper-demo {
        animation: showMenuAnimation 0.5s normal forwards;
      }
    }
  }
}

@media (max-width: 800px) {
  // 头部
  @include b(layout-header) {
    @include e(left) {
      transform: scale(0.8);
      transform-origin: left center;
    }
    @include e(right) {
      .menuIcon {
        opacity: 1 !important;
      }
      .el-menu-popper-demo {
        animation: hideMenuAnimation 0.5s normal forwards;
      }
    }
  }
}
</style>
